import { TeiaSearchGroup } from '@stereograph/teia-system-design/utils';

export const uuidsToAdvancedSearch = (uuids: Iterable<string>): TeiaSearchGroup => {
  return {
    condition: 'Or',
    rules: Array.from(uuids).map((uuid) => ({
      type: 'Guid',
      operator: 'EqualTo',
      value: uuid,
    })),
  };
};
